import { useMemo } from 'react'
import { CustomerCart } from 'models/IDeliveryOrder'

export interface CartItemsProps {
  restaurantName?: string
  restaurantCurrency: string
  cartData: CustomerCart[] | null
}

export const useCartItems = (props: CartItemsProps) => {
  const { cartData } = props

  const totalPrice = useMemo(() => {
    if (!cartData) return 0

    return cartData.reduce((total, item) => {
      return total + Number(item.price || 0) * item.quantity
    }, 0)
  }, [cartData])

  return {
    ...props,
    totalPrice,
  }
}
